var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fe-calendar"},[_c('client-only',[_c('my-calendar',{attrs:{"mark-date":_vm.markDates,"sunday-start":true,"text-top":_vm.textTop},on:{"changeMonth":_vm.changeMonth}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }